module.exports = __webpack_public_path__ + "media/shelter_materials/shelter_banner_large_2x-60723d9a.png";